import React from 'react';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import { OperationMS } from '../types';
import { CommandeAnalyse } from '../domain/analyse/types';
import { buildPreparationRecap } from '../domain/marche/preparation';

// Section « Préparation du Marché Subséquent » : recap read-only des infos MS + titulaire retenu
// (aucun fetch propre — tout vient de `operation` + `retenu`).
interface OperationMarchePreparationProps {
  operation: OperationMS;
  retenu?: CommandeAnalyse;
}

const OperationMarchePreparation: React.FC<OperationMarchePreparationProps> = ({ operation, retenu }) => {
  const fields = buildPreparationRecap(operation, retenu);

  return (
    <SectionPliable title="Préparation du Marché Subséquent" defaultOpen>
      <div className="opms__marche-body">
        <div className="opms__recap-grid">
          {fields.map((field) => (
            <div className="opms__recap-field" key={field.label}>
              <span className="opms__recap-label">{field.label}</span>
              <span className="opms__recap-value">{field.value}</span>
            </div>
          ))}
        </div>
      </div>
    </SectionPliable>
  );
};

export default OperationMarchePreparation;
